import styled from 'styled-components'

export const DonutRoot = styled.div`
  position: relative;
  flex: 0 0 auto;
  max-width: 100%;
`

/** Under the chart, seen through its transparent hole, so the tooltip draws over it. */
export const DonutCentre = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;
`

/** The chart above the centre text; its own background is transparent. */
export const DonutLayer = styled.div`
  position: relative;
  z-index: 1;
`
